import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class PointOfSaleTypeProductForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="product"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Termék"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="type"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Eladási hely típus"
                            storeType="local"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="optimalstock_limit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Optimális szint"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="lowstock_limit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Figyelmeztetési szint"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="outofstock_limit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Készlethiány-szint"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(PointOfSaleTypeProductForm);
